import { useSelector } from 'react-redux';
import { selectors } from 'darwin_core';

import HotWaterRadial from './HotWaterRadial.jsx';

// The hot-water dial wired to darwin_core for one cylinder — the counterpart of
// SetpointDial, which the zone screen renders in the same column for a heating
// zone. There is nothing to dispatch: a cylinder has no user setpoint, so this
// only reads.
//
// getDhwActiveMode is the app's own source for the big word: it folds the mode,
// the running schedule event and holiday into the live On/Off (holiday and Off
// both read Off, an override reads On), so no state needs re-deriving here. It
// walks the reported schedule with no shape checks and can throw for a zone that
// has never reported one, so read it defensively exactly as the property tile
// does — a bad frame must leave a muted dial, never take the zone screen down.
export default function HotWaterDial({ homeId, zoneId }) {
  const online = useSelector((s) => selectors.isZoneOnline(s, homeId, zoneId));
  const dhwActiveMode = useSelector((s) => {
    try {
      return selectors.getDhwActiveMode(s, homeId, zoneId);
    } catch {
      return '';
    }
  });

  return <HotWaterRadial dhwMode={dhwActiveMode} offline={!online} />;
}
